import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import { convokePlacesOption, donationTypeExtraction,preOffersSearch } from '../../libs/services';

var Config = require('../../config');

class DonationData extends Component{

    constructor(props, context) {
		super(props, context);

        this.onSearch = this.onSearch.bind(this);
        this.state = {
            convoke_places:[],
            extraction_types:[],
            hours:[],
            start_date:"",
            different_date:false,
            timestamp_date_new:null,
            timestamp_hour_new:null,
		};
   
        console.log(this.props)
	}

    async componentDidMount(){
        var response = await convokePlacesOption('operatives', sessionStorage.getItem("health_facilities_id"));
        if(response !== undefined){
            this.setState({
                convoke_places: response
            });
        }
       
        response = await donationTypeExtraction("no_cells");
        if(response !== undefined){
            this.setState({
                extraction_types: response
            });
        }

       
    }
    handleChange(e){
    if(e.target.name=="different_date")
        this.setState({
                [e.target.name]: e.target.checked
            });


    else{
		this.setState({
			[e.target.name]: e.target.value
		});
    }

		document.getElementById(e.target.id).classList.remove('error');
        if(e.target.name=='start_date')
            this.onSearch(e.target.value)

	}
    async onSearch(date){
        var response = await preOffersSearch(date, this.props.state.convoke_places_id, this.props.state.donation_type_extraction_id);

        if(response !== undefined){
                this.setState({ hours: response });
        }else{
            this.setState({ hours: [], events:[] });
            }
    
          
        }

    newEvent(e, hour){
		e.preventDefault();
        console.log("DATE");

        this.props.handleChangeCompleteDate(this.state.start_date, hour);
        //this.props.handleChangeCompleteDate.bind(this.state.start_date,hour)
        // this.setState({
        //     timestamp_date_new: this.state.start_date,
		// 	timestamp_hour_new: hour
		// });
		
	}
    render(){
        const { t } = this.props;
        return(
             <div className="col-xs-12" style={{padding:"0px"}}>
                <div className="col-xs-12" style={{padding:"0px"}}>
                    {this.props.showField("offer", "date")?
                        <div className="col-xs-12 col-sm-2" >
                            <span className="span-min">Fecha Cita</span>
                            <input className="form-control hour-input" type="date" name="timestamp_date" id="timestamp_date"
                                value={ this.props.state.timestamp_date } disabled required/>
                        </div>
                    :null}

                    {this.props.showField("offer", "hour")?
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Hora Cita</span>
                            <input id="timestamp_hour" name="timestamp_hour" type="text" data-inputmask-alias="datetime" 
                                data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
                                value={this.props.state.timestamp_hour || ""} 
                                className="form-control"  disabled required/>
                        </div>
                    :null}

                    
                    <div className="col-xs-12 col-sm-3">
                        <span className="span-min">{t('content.offers.form.convoke_place')}</span>
                        <select className="form-control"
                            value={ this.props.state.convoke_places_id || "" } onKeyPress={(e) => this.props.validate(e)}
                            onChange={ this.props.selectFieldHandle.bind(null,"id","convoke_places_id") } autoFocus={true}
                            name="convoke_places_id" id="convoke_places_id" disabled>
                                <option value="">Seleccionar...</option>
                            {
                            this.state.convoke_places.map(function(t) {
                                return <option key={t.convoke_places.id}  value={t.convoke_places.id} >{t.convoke_places.name} </option>;
                            })
                        }
                        </select>
                    </div>		        

                    
                    <div className="col-xs-12 col-sm-2">
                        <span className="span-min">{t('content.offers.form.extraction_type')}</span>
                        <select className="form-control" onKeyPress={(e) => this.props.validate(e)}
                            value={ this.props.state.donation_type_extraction_id || ""} 
                            onChange={ this.props.extractionTypeSelected.bind(null,"id","donation_type_extraction_id") }
                            name="donation_type_extraction_id"id="donation_type_extraction_id" disabled>
                            <option value="" disabled>Seleccionar...</option>
                            {
                            this.state.extraction_types.map(function(t) {
                                return <option key={t.id} value={t.id} >{t.donation_type_process}</option>;
                            })
                        }
                        </select>
                    </div>

                    {this.props.showField("offer", "donation_type")?
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">{t('content.offers.form.donation_type')}</span>
                            <select className="form-control" name="donation_type_id" id="donation_type_id" 
                                value={ this.props.state.donation_type_id || ""} onKeyPress={(e) => this.props.validate(e)}
                                onChange={ this.props.donationTypeSelected.bind(null,"id","donation_type_id") } required>
                                <option value="" disabled >Seleccionar...</option>
                                {
                                this.props.state.donation_types.map(function(t) {
                                    return <option key={t.donation_type.id} value={t.donation_type.id} >{t.donation_type_lookup}</option>;
                                })
                            }
                            </select>
                        </div>
                    :null}
                </div>
                 {this.props.state.flagEdit?
                <div className="col-xs-12">
                    <input type="checkbox" name="different_date" id="different_date" value={this.state.different_date}
                        checked={this.state.different_date} onChange={(e)=>this.handleChange(e)} /> <span className="span-min">Cambiar Fecha y Hora</span>
                </div>:null}
                <div hidden={!this.state.different_date}>
                    <div className="col-xs-12" style={{padding:"0px"}}>
                        <div className="col-xs-12 col-sm-2">
                                <span className="span-min">Fecha </span>
                                <input type="date" name="start_date" id="start_date" value={this.state.start_date} 
                                onChange={(e)=>this.handleChange(e)}
                                //  className={`form-control hour-input ${this.state.errorStartDate?'error':''}`}
                                />
                        </div>
                    </div>
                    <div className="col-xs-12 p-0" style={{padding:"0px"}}>
                        {this.state.hours.map((h, i)=>{
                            return <div className="col-xs-1  col-sm-2 col-md-2" key={i}>
                                <button className="btn" style={{margin:"2px", backgroundColor:h.color}} 
                                onClick={e =>this.newEvent(e,h.start)}
                                 disabled={h.full || h.locked}
                                >
                                    <span>{h.start +" - "+h.end}</span>
                                </button>
                            </div>
                        })}
                    </div>
                </div>
             </div>
        );
    }
}

export default translate('translations')(DonationData);